<template>
  <div>
    <typhoonReport ref="typhoonReport"/>
  </div>
</template>

<script>
import typhoonReport from '@/components/typhoon/typhoon.vue';

export default {
  components: {
    typhoonReport,
  },
};
</script>
